import script from "./TableNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TableNav.vue?vue&type=script&setup=true&lang=js"

import "./TableNav.vue?vue&type=style&index=0&id=c773419a&lang=less"

const __exports__ = script;

export default __exports__